import { render, staticRenderFns } from "./JPageSearch.vue?vue&type=template&id=50a27adc"
import script from "./JPageSearch.vue?vue&type=script&lang=js"
export * from "./JPageSearch.vue?vue&type=script&lang=js"
import style0 from "./JPageSearch.vue?vue&type=style&index=0&id=50a27adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports